import { useTranslation } from 'react-i18next';
import ReactHtmlParser from 'react-html-parser';

const TextoPoliticas = ({ lang, textopoliticas }) => {

    const { t } = useTranslation();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    /* var textopolitica = t("En Onboard Holidays trabajamos con diversas compañías de embarcaciones en distintos destinos, por lo que las políticas de cancelación pueden variar según la goleta, catamarán o mini crucero seleccionado. Cuando realices una solicitud de disponibilidad, te proporcionaremos toda la información detalladasobre la política de cancelación aplicable a la embarcación y destino de tu interés. Para garantizar tu tranquilidad, muchas de nuestras opciones incluyen condiciones flexibles y la posibilidad de contratar un seguro de cancelación, permitiéndote modificar o cancelar tu viaje bajo términos favorables")*/

    return (
        <>
            <section className="u-clearfix u-image u-valign-middle-lg u-valign-middle-sm u-section-1" id="sec-5458" data-image-width="1615" data-image-height="908" style={{ backgroundImage: "url(images/web/onboard2/13--AMADA-MIA-platform-closer-top-view-14.jpg)" }} >
                <h1 className="u-align-center u-custom-font u-font-oswald u-text u-text-default u-text-white u-title u-text-1">{t("POLÍTICA DE CANCELACIÓN")}</h1>
            </section>
            <section className="u-clearfix u-section-2" id="block-10">
                <div className="u-clearfix u-sheet u-valign-middle-lg u-valign-middle-sm u-valign-middle-xl u-sheet-1">
                    <p className="u-align-justify u-custom-font u-font-montserrat u-text u-text-body-color u-text-1" data-animation-name="customAnimationIn" data-animation-duration="1500" data-animation-delay="250" data-animation-out="0">
                        {ReactHtmlParser(textopoliticas.ladesc)}
                        {/* ReactHtmlParser(textopolitica.replaceAll("**", "<b>").replaceAll("++", "</b>"))*/}
                        <br />
                        <br />{t("Si tienes alguna duda, nuestro equipo estará encantado de asesorarte antes de confirmar tu reserva.")}
                    </p>
                </div>
            </section>
        </>
    );

};
export default TextoPoliticas;
